import React from 'react';
import PropTypes from 'prop-types';
import BuyIcon from '@tradera/blueprint/theme/icons2/buy.svg?jsx';
import BuyMenu from './buy-menu';
import { HOVER_MENUS } from './hover-menu/constants';
import { useTranslator, useUrlLocalizer } from 'static/script/app/lang';

const BuyingLink = ({ onClick, mouseOver, mouseOut, onBlur, showMenu }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const buyingText = t('siteHeader_buying');
    return (
        <div
            onMouseEnter={() => mouseOver(HOVER_MENUS.BUY)}
            onMouseLeave={mouseOut}>
            <a
                href={toLocalizedUrl('/my/active-items')}
                rel="nofollow"
                aria-label={buyingText}
                className={`btn btn-link-branded px-3 d-flex align-items-center ${
                    showMenu ? 'active' : ''
                }`}
                title={buyingText}
                data-ga-category="Top navigation"
                data-ga-action="Buying menu"
                data-ga-label="Link - Ongoing auctions from NavBar"
                onClick={e => {
                    onClick(e, HOVER_MENUS.BUY);
                }}
                onBlur={onBlur}
                tabIndex={-1}>
                <BuyIcon className="icon" />
                <span className={`slim-header__link-text d-none d-xl-inline`}>
                    {buyingText}
                </span>
            </a>
            <BuyMenu showMenu={showMenu} />
        </div>
    );
};

BuyingLink.propTypes = {
    onClick: PropTypes.func,
    mouseOver: PropTypes.func,
    mouseOut: PropTypes.func,
    showMenu: PropTypes.bool
};

export default BuyingLink;
